import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { Menu } from "@headlessui/react";
import { NormalizedDisclosure } from "~/types/search.types";

import { CheckIcon } from "@heroicons/react/16/solid";
import { Language } from "~/providers/LanguageProvider";

interface IDisclosureMenuItem {
    disclosure: NormalizedDisclosure;
    isSelected: boolean;
    btnClickCallback: (item: NormalizedDisclosure) => void;
}

/** Disclosure dropdown list item elements */
const DisclosuresMenuItem = (props: IDisclosureMenuItem) => {
    const { disclosure, isSelected, btnClickCallback } = props;
    const { i18n } = useTranslation();

    const disclosureText = disclosure?.label[i18n.language as Language];
    const checkIconStyle = clsx("h-4 w-4 text-caramel-vibrant", isSelected ? "visible" : "invisible");

    return (
        <Menu.Item>
            <button
                className="group flex w-full items-center gap-2 h-9 p-2 text-sm text-stone-darkest text-left font-medium-light rounded-md bg-transparent hover:bg-stone-lighter"
                onClick={() => btnClickCallback(disclosure)}
            >
                <CheckIcon className={checkIconStyle} />
                <div>
                    {disclosureText}
                </div>
            </button>
        </Menu.Item>
    );
}

export default DisclosuresMenuItem;
